import { StateStatus } from '../../enums/StateStatus';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';

export interface Barrier {
  id: number;
  serialNumber: string | null;
  barrierGateSerialNumber: string | null;
  inventoryNumber: string | null;
  locations: BarrierLocation[];
  mode: BarrierDeviceMode;
  lastPing: string;
  description: string;
}

export interface BarrierLocation {
  type: BarrierLocationType;
  id: number;
  label: string;
  deliveryZoneIndex: number;
  deliveryZoneName: string;
}

export enum BarrierLocationType {
  None = 'None',
  WarehouseZell = 'WarehouseZell',
  WarehouseNord = 'WarehouseNord',
  Project = 'Project'
}

export enum BarrierDeviceMode {
  Offline = 'Offline',
  Online = 'Online',
  ServiceMode = 'ServiceMode'
}

export interface BarriersState {
  barriers: Barrier[] | null;
  status: StateStatus;
  error: RestErrorResponse | null;
  barrier: Barrier | null;
  barrierLogs: BarrierLog[];
}

export interface BarrierFormData {
  serialNumber: string;
  barrierGateSerialNumber: string;
  inventoryNumber: string;
  locationType: string;
  locationId: number;
  description: string;
}

export interface BarrierModeData {
  ipAddress: string;
  port: string;
}

export interface BarrierLog {
  type: BarrierLogType;
  logDateTimeUtc: string;
  pin: string;
  result: boolean;
  resultDetails: string;
}

export enum BarrierLogType {
  Alive = 'Alive',
  Access = 'Access',
  ConstructionSiteAssigned = 'ConstructionSiteAssigned',
  DeliveryZoneAssigned = 'DeliveryZoneAssigned',
  System = 'System'
}
